export default __webpack_public_path__ + "ku_light_fr.36d699a1.svg";